
import axios from 'axios'
export default {
  components: {},
  props: [],
  name: 'home-page',
  data () {
    return {
      valueName: '',
      time: null
    }
  },
  created () {
    this.setWXShareInfo()
  },
  methods: {
    godetail (type) {
      console.log('godetail type: ', type)
      if (type === 4) {
        this.$router.push({ path: '/ipqDetailPage', level1: type })
      } else if (type === 5) {
        this.$router.push({ path: '/qnDetailPage', level1: type })
      } else {
        // 由于普通详情页需要多选项目类型，所以这里level1改成了数组
        this.$router.push({ path: '/detailPage', query: { level1: type, name: this.name } })
      }
    },
    goImg (type) {
      this.$router.push({ path: '/detail', query: { type: type } })
    },

    async querySure () {
      clearTimeout(this.time)
      this.time = setTimeout(() => {
        if (this.valueName) {
          this.$router.push({ path: '/detailPage', query: { level1: null, name: this.valueName } })
        }
      }, 600)
    },
    async setWXShareInfo () {
      const currentRouter = this.$router.currentRoute.fullPath
      const basehref = `https://sou-tools.gecacademy.cn${currentRouter}`
      const shareTitle = 'Path Academics'
      const shareDesc = 'Light Your Path. Walk Your Way'
      const shareImgUrl = 'https://gecacademy.oss-cn-beijing.aliyuncs.com/oa/upload/2021-04-30%2016-47-46-WechatIMG4292.jpeg'
      const shareInfo = {
        title: shareTitle,
        desc: shareDesc,
        link: basehref,
        imgUrl: shareImgUrl,
        success () {},
        cancel () {}
      }
      const test = Math.random()
      const timestamp = parseInt(new Date() / 1000)
      const params = {
        timestamp,
        noncestr: String(test),
        url: basehref,
        appName: 'sou-tools'
      }
      // const result = await axios.get('https://api.gecacademy.cn/pay/wx/signature', {
      //   params
      // })
      // const signature = result.data.data
      // console.log(result)
      const result = await axios.post('https://gec-api.gecacademy.cn/souapi/wechat/sellTool/getSign', params)
      const signature = result.data.data.signature
      const wx = this.$wx
      await wx.configAsync({
        debug: false,
        appId: 'wxf88eda53c74e883f',
        timestamp,
        nonceStr: String(test),
        signature,
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'chooseImage',
          'previewImage',
          'uploadImage',
          'chooseWXPay'
        ]
      })
      // wx.onMenuShareTimeline(shareInfo)
      wx.onMenuShareAppMessage(shareInfo)
      // wx.updateAppMessageShareData(shareInfo)
      wx.updateTimelineShareData(shareInfo)
    }
  }
}
